import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var UnknownSvg = function UnknownSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#6356F6",
      d: "M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M12 5.334a6.667 6.667 0 1 1 0 13.333 6.667 6.667 0 0 1 0-13.333m0 .833a5.833 5.833 0 1 0 0 11.667 5.833 5.833 0 0 0 0-11.667m0 8.333.068.004a.625.625 0 1 1-.136 0zm2.03-4.634a2.083 2.083 0 0 1-1.335 2.432.42.42 0 0 0-.274.335l-.004.058v.56a.417.417 0 0 1-.83.056l-.003-.057v-.559c0-.498.295-.946.746-1.145l.087-.034a1.25 1.25 0 1 0-1.664-1.269l-.003.09a.417.417 0 0 1-.833 0 2.083 2.083 0 0 1 4.113-.467",
      clipRule: "evenodd"
    })]
  });
};
export var Unknown = function Unknown(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: UnknownSvg
  }));
};